import { GoalApprovalStatus } from "@gtmhub/goals/models";
import { IController, IComponentOptions } from "angular";

export class GoalApprovalStatusLabelCtrl implements IController {
  status: GoalApprovalStatus;
}

export const GoalApprovalStatusLabelComponent: IComponentOptions = {
  template: `
    <div 
      class="goal-approval-status-wrapper" 
      ng-class="{
        'draft': $ctrl.status === 'draft',
        'in-review': $ctrl.status === 'inReview',
        'approved': $ctrl.status === 'approved'
      }"
    >
      <span class="goal-approval-status-icon"
        ng-class="{'gh-font-icon-inline': $ctrl.status === 'draft', 'gh-font-icon-clock': $ctrl.status === 'inReview', 'gh-font-icon-done': $ctrl.status === 'approved'}">
      </span>
      <span class="goal-approval-status-text">{{ $ctrl.status | localize }}<span>
    </div>`,
  controller: GoalApprovalStatusLabelCtrl,
  bindings: {
    status: "<",
  },
};
